import UserRole from 'app/enums/UserRole'

export default function(input){

    switch(input){

        case UserRole.USER: return 'Gebruiker';
        case UserRole.ADMIN: return 'Admin';
        case UserRole.CONTRACTOR: return 'Aannemer';
        case UserRole.WORKER: return 'Uitvoerder intern';
        case UserRole.SUPPLIER: return 'Leverancier (algemeen)';
        case UserRole.SUPPLIER_ALTITUDE: return 'Leverancier hoogtemetingen';
        case UserRole.SUPPLIER_VIBRATION: return 'Leverancier trillingsmetingen';
        case UserRole.ADVISOR: return 'Adviseur';
        case UserRole.ADVISOR_EXTERNAL: return 'Adviseur extern';
        case UserRole.RESIDENT: return 'Bewoner';

        default: return '';
    }
}